import React, { Component } from 'react';

import Input from '../commons/component/input';
import InputNumber from '../commons/component/input-number';
import Button from '../commons/component/button';
import CustomerConfirm from './customer-confirm-component';
import PopUp from '../commons/component/popup';
import onlyNumbers from '../commons/utils/only-numbers';

import { pushOrRedirect } from '../commons/query';

import { B2W_WITH_TELEMARKETER } from '../api/customer/login';
import { persisteCustomerAndDispatchEvents } from '../api/customer/persiste-customer';
import {
  getStepAfterLogin,
  loginCustomerWithTelemarketer,
  loginBuyerWithTelemarketer,
  getErrorMessageByErrorCode
} from './entrar-action';
import config from '../generated/config';

const hasOnlyNumbers = text => /^\d+$/g.test(text);

class EntrarTelemarketerWithCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      defaultErrorMessage: 'Dados incorretos',
      errorMessage: '',
      email: '',
      cnpj: '',
      popup: {
        isShowing: false,
        title: '',
        content: null
      },
      tokenResult: {},
      customer: {}
    };
  }

  render() {
    const { isSubmitting, errorMessage, email, popup, cnpj } = this.state;
    const { brand, showCNPJOnLogin } = config;

    return (
      <div className="entrar__wrapper --telemarketer">
        <PopUp isOpened={popup.isShowing} title={popup.title} onClose={this.closePopUp}>
          {() => popup.content}
        </PopUp>

        <h2 className="entrar-title">
          <span>Já tenho cadastro</span>
        </h2>
        <form onSubmit={this.submitLogin}>
          {errorMessage && <span className="entrar-formError --zeroLeft">{errorMessage}</span>}
          {showCNPJOnLogin && (brand === 'aemp' || brand === 'prtl') && (
            <label className="entrar-inputBlock --column" id="cnpj">
              <label className="inputGroup-label --acronym" htmlFor="cnpj-input">
                CNPJ:
              </label>
              <InputNumber
                name="cnpj"
                id="cnpj-input"
                data-page="login"
                data-form="login"
                onChange={this.handleChange.bind(this)}
                value={cnpj}
                className="entrar-input form-control"
                maxLength="14"
                type="text"
                mask="__.___.___/____-__"
                placeholder="Ex: 12.345.678/1234-56"
                disabled={isSubmitting}
                required
              />
            </label>
          )}

          <label className="entrar-inputBlock --column" id="emai">
            <label className="entrar-inputLabel">E-mail:</label>
            <Input
              id="email-input"
              name="email"
              type="text"
              value={email}
              placeholder="Ex. joaodasilva@gmail.com"
              className="entrar-input form-control"
              data-page="login"
              data-form="login"
              onChange={this.handleChange.bind(this)}
              disabled={isSubmitting}
              required
            />
          </label>

          <Button
            id="login-button"
            primary
            disabled={isSubmitting}
            loading={isSubmitting}
            className="entrar-button"
          >
            Continuar
          </Button>
        </form>

        <p className="divisor is-3">
          <span>ou</span>
        </p>

        <h2 className="entrar-title">
          <span>Não tenho cadastro</span>
        </h2>
        <Button
          primary
          className="entrar-button"
          onClick={() => {
            this.redirect(`/cadastro${this.props.location.search}`);
          }}
        >
          Criar cadastro
        </Button>
      </div>
    );
  }

  handleChange = ({ target }) => {
    const { name, value } = target;
    this.setState({
      [name]: value
    });
  };

  turnLoadingOn = () => {
    this.setState({
      isSubmitting: true,
      errorMessage: ''
    });
  };

  turnLoadingOff = () => {
    this.setState({
      isSubmitting: false,
      errorMessage: ''
    });
  };

  setErrorMessage = ({ errorCode }) => {
    this.setState(state => ({
      errorMessage: getErrorMessageByErrorCode(errorCode, state.defaultErrorMessage)
    }));
  };

  redirect(url) {
    return e => {
      e.preventDefault();
      pushOrRedirect(this.props.history.push, {
        url: url,
        push: true
      });
    };
  }

  setCustomer = (tokenResult, customer) => {
    this.setState({ tokenResult, customer });
  };

  clearCustomer = () => {
    this.setCustomer({}, {});
  };

  submitLogin = event => {
    event.preventDefault();
    this.turnLoadingOn();
    if (config.brand === 'aemp' || config.brand === 'prtl') {
      loginBuyerWithTelemarketer({ email: this.state.email, cnpj: onlyNumbers(this.state.cnpj) })
        .then(({ tokenResult, customer }) => {
          this.setCustomer(tokenResult, customer);
          if (hasOnlyNumbers(this.state.email)) {
            this.showCustomerConfirmPopUp();
          } else {
            return this.persisteLogin(tokenResult, customer);
          }
        })
        .catch(error => {
          this.turnLoadingOff();
          this.clearCustomer();
          this.setErrorMessage(error);
        });
    } else {
      loginCustomerWithTelemarketer({ username: this.state.email })
        .then(({ tokenResult, customer }) => {
          this.setCustomer(tokenResult, customer);
          if (hasOnlyNumbers(this.state.email)) {
            this.showCustomerConfirmPopUp();
          } else {
            return this.persisteLogin(tokenResult, customer);
          }
        })
        .catch(error => {
          this.turnLoadingOff();
          this.clearCustomer();
          this.setErrorMessage(error);
        });
    }
  };

  persisteLogin = (tokenResult, customer) => {
    try {
      this.turnLoadingOff();
      this.clearCustomer();
      persisteCustomerAndDispatchEvents({
        token: tokenResult,
        customer,
        type: B2W_WITH_TELEMARKETER
      });
      const url = getStepAfterLogin({ customer });
      pushOrRedirect(this.props.history.push, url);
    } catch (error) {
      this.turnLoadingOff();
      this.setErrorMessage(error);
    }
  };

  showPopUp = (title, content) => {
    this.setState({ popup: { isShowing: true, title, content } });
  };

  closePopUp = () => {
    this.turnLoadingOff();
    this.clearCustomer();
    this.setState({
      email: '',
      popup: { isShowing: false, title: '', content: null }
    });
  };

  onConfirm = () => {
    this.closePopUp();
    this.persisteLogin(this.state.tokenResult, this.state.customer);
  };

  showCustomerConfirmPopUp = () => {
    const title = 'Confirmação de usuário';
    const content = (
      <CustomerConfirm
        email={this.state.tokenResult.login}
        onConfirm={this.onConfirm}
        closePopUp={this.closePopUp}
      />
    );
    this.showPopUp(title, content);
  };
}

export default EntrarTelemarketerWithCustomer;
